import { KeyCombinations } from "@kuika/kuika-cl-model";
import { PartialContextProvider } from "../../../shared/patial/partial-context-provider";
import { IScreenDesignContextState } from "../screen-design-context";
import { IScreenDesignContextProviderProps, ScreenDesignContextProvider } from "../screen-design-context-provider";

export interface NavigateProviderState {
  navigateWithKeyCombinations: (keyCombination: KeyCombinations) => void;
}

export class NavigateProvider extends PartialContextProvider<
  ScreenDesignContextProvider,
  IScreenDesignContextProviderProps,
  IScreenDesignContextState,
  NavigateProviderState
> {
  static defaultState: NavigateProviderState = {
    navigateWithKeyCombinations: () => {}
  };

  getProviderValues = (): NavigateProviderState => {
    return {
      navigateWithKeyCombinations: this.navigateWithKeyCombinations
    };
  };

  navigateWithKeyCombinations = (keyCombination: KeyCombinations) => {
    if (keyCombination === KeyCombinations.alt4) {
      this.props.navigator.gotoProjects();
    } else if (keyCombination === KeyCombinations.alt5) {
      this.props.navigator.gotoComponents();
    }
  };
}
